import React from 'react';
import { SubmitHandler, UseFormReturn, useForm, FieldValues, Resolver, DefaultValues, SubmitErrorHandler } from 'react-hook-form';

type FormProps<TFormValues extends FieldValues> = {
  defaultValues?: DefaultValues<TFormValues>;
  keepValuesOnReset?: boolean;
  keepDirtyValuesOnReset?: boolean;
  keepDirtyOnReset?: boolean;
  keepErrorsOnReset?: boolean;
  resolver: Resolver<TFormValues>;
  onSubmit: SubmitHandler<TFormValues>;
  onError: SubmitErrorHandler<TFormValues>;
  children: (methods: UseFormReturn<TFormValues>) => React.ReactNode;
  className?: string;
};

const Form = <TFormValues extends Record<string, any>>({
  keepValuesOnReset,
  keepDirtyValuesOnReset,
  keepDirtyOnReset,
  keepErrorsOnReset,
  defaultValues,
  resolver,
  onSubmit,
  children,
  onError,
  className
}: FormProps<TFormValues>) => {
  const methods = useForm<TFormValues>({ 
    resetOptions: { 
      keepValues: keepValuesOnReset ?? false,
      keepDirtyValues: keepDirtyValuesOnReset ?? false, 
      keepDirty: keepDirtyOnReset ?? false, 
      keepErrors: keepErrorsOnReset ?? false 
    }, 
    defaultValues, resolver 
  });
  return (
    <form className={className} onSubmit={methods.handleSubmit(onSubmit, onError)}>{children(methods)}</form>
  );
};

export default Form;
